import React from "react"
import { ArrowRightIcon } from "@phosphor-icons/react"
import { Link, navigate } from "gatsby"

const CollabCard = ({
	data,
	className = "relative block w-full md:w-56 lg:w-64 h-[220px] md:h-auto overflow-hidden cursor-pointer",
	showButton = false,
}) => {
	return (
		<React.Fragment>
			<Link
				to={data?.link ?? '/'}
				className={`${className}`}
				aria-label={`${data?.title}-${data?.subTitle}`}
			>
				<div className="relative">
					<div className="absolute w-full h-full flex flex-col justify-start items-center text-white">
						<div className="mt-2 px-4 w-full text-center">
							{/* <p className="text-2xl font-medium">{data?.title}</p> */}
							<p className="text-s">{data?.subTitle}</p>
						</div>
					</div>
					<img
						className="w-full object-cover"
						src={data?.mobileBannerImage}
						alt={data?.title}
					/>
				</div>
				{showButton && (
					<button className="absolute md:relative flex items-center justify-center gap-x-2 min-w-40 w-max px-4 md:w-full mt-2 border border-gray-300 bg-white text-primary py-2 text-xs md:text-sm bottom-0 right-0 m-4 md:m-0">
						{data?.title}
						<ArrowRightIcon size={16} weight="light" />
					</button>
				)}
			</Link>
		</React.Fragment>
	)
}

export default CollabCard
